import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Constants } from '../constants';
import { FGAData } from '../fga/models';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  public details$ = new BehaviorSubject<FGAData>(null);
  constants: Constants = new Constants();
  HTTP_CONSTANT_OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json, application/x-www-form-urlencoded;charset=ISO-8859-15',
      'Accept': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
      'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token, X-Requested-With, Accept, Access-Control-Request-Method, Authorization'
    })
  };
 
  constructor(private readonly http: HttpClient) { }

  getUserDetails(): Observable<any> {
    return this.http
      .get(this.constants.getApiBasePath() + '/alarms/api/v1/getusers', this.HTTP_CONSTANT_OPTIONS)
      .pipe(
        tap(_ => this.log('User Details Success!')),
        catchError(this.handleError<any>('User Details Failed!'))
      );
  }

  getUserInfo(toyotaGUID: string): Observable<any> {
    const path = this.constants.getApiBasePath() + '/alarms/api/v1/getuserinfo/' + toyotaGUID;
    return this.http
      .get(path, this.HTTP_CONSTANT_OPTIONS)
      .pipe(
        tap(_ => this.log('User Information Success!')),
        catchError(this.handleError<any>('User Information Fails!'))
      );
  }

  private handleError<T>(result?: T) {
    return (error: any): Observable<T> => {
      console.info(error);
      return of(result as T);
    };
  }

  private log(message: string) {
    console.info('Message: ' + message);
  }

  getDetails(): Observable<FGAData> {
    return this.details$.asObservable();
  }

}
